var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Statistics")])]),(_vm.noSelection)?_c('infoSnack',{attrs:{"snackMessage":_vm.snackMessage,"snackType":_vm.snackType},on:{"onSnackClose":_vm.closeSnackbar}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }